/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mention-timeline-container[_ngcontent-%COMP%]{margin-left:50px;margin-right:20px}  achoo-stacked-column-chart .highcharts-legend .highcharts-legend-item .highcharts-legend-item-text{font-weight:400}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/mention-timeline-report/mention-timeline-report.component.scss.shim.ngstyle.js.pre-build-optimizer.js